import React from 'react'
import './loader.scss'

export default function Loader() {
    return (
        <div className='loader-wrapper'>
            <div className='loader'></div>
        </div>
    )
}
